import type { QueryDefinition } from '@reduxjs/toolkit/dist/query';
import type { UseQueryHookResult } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { useEffect } from 'react';

type SideEffectFn = (originalArgs?: Record<string, any>) => void;

type EffectMap = {
    isLoading?: SideEffectFn;
    isSuccess?: SideEffectFn;
    isError?: SideEffectFn;
    isUninitialized?: SideEffectFn;
    isFetching?: SideEffectFn;
};

interface EffectProps {
    queryState: UseQueryHookResult<QueryDefinition<any, any, any, any>>;
    effects: EffectMap;
}

export const QueryEffect = ({ queryState, effects }: EffectProps) => {
    const { isError, isSuccess, isFetching, isLoading, isUninitialized, originalArgs } = queryState;

    useEffect(() => {
        isSuccess && effects.isSuccess && effects.isSuccess(originalArgs);
        isLoading && effects.isLoading && effects.isLoading(originalArgs);
        isError && effects.isError && effects.isError(originalArgs);
        isUninitialized && effects.isUninitialized && effects.isUninitialized(originalArgs);
        isFetching && effects.isFetching && effects.isFetching(originalArgs);
    }, [queryState]);

    return <></>;
};
